import index from "./planReport.vue";
export default index;
